import { LineSeparatorLineVariantType } from '../variants';
export const getRegularVerticalStyles = (FOUNDATIONS, FONT) => {
    return {
        [LineSeparatorLineVariantType.REGULAR_VERTICAL]: {
            lineSeparatorRootWrapper: {
                width: '0%',
                height: '100%',
                border_style: 'solid',
                border_width: '0.031rem',
                border_color: FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border,
            },
        },
    };
};
//# sourceMappingURL=regularVertical.js.map